import { ReactNode } from 'react';

import { Separator } from '../../separator/Separator';
import { SeparatorIdentifier } from '../../separator/Separator.enums';

import './ModalContentActionBar.scss';

export type ModalContentActionBarProps = {
    children: ReactNode;
    showSeparator?: boolean;
};

export const ModalContentActionBar = (props: ModalContentActionBarProps) => {
    const { children, showSeparator = true } = props;

    return (
        <article className="modal-content-action-bar">
            {showSeparator && <Separator separatorType={SeparatorIdentifier.ON_LIGHT} />}
            <article className="modal-content-action-bar__actions">{children}</article>
        </article>
    );
};
